'use strict';

module.exports = {
    client: require('./lib/client'),
    nodeClient: require('./lib/client-node'),
}